export default "__VITE_ASSET__M3w1R8M1__"